export const JOYRIDE_TOURGUIDE_STYLES_DEFAULT = {
    options: {
        arrowColor: '#FFFFFF',
        zIndex: 201,
        beaconSize: 24,
    },
    beacon: {
        top: 8,
        left: 0,
    },
};

export const JOYRIDE_TOURGUIDE_FLOATER_STYLES_DEFAULT = {
    floater: {
        transition: 'opacity 0.75s ease-in-out',
        filter: 'drop-shadow(0px 1px 17px rgba(40, 44, 53, 0.1)) drop-shadow(0px 2px 5px rgba(40, 44, 53, 0.1))',
    },
    floaterClosing: {
        transition: 'opacity 0.75s ease-in-out',
    },
};
